<template>
  <div>
    <h3>Deals</h3>
    <b-form-group label-class="form-control-label" label-for="pipeline" class="mb-0" v-if="pipelines">
      <b-form-select v-model="pipelineId" @change="getDeals">
        <b-form-select-option :value="''">Filter by Pipeline</b-form-select-option>
        <b-form-select-option v-for="pipeline in pipelines" :key="pipeline.id" :value="pipeline.id">{{ pipeline.name }}</b-form-select-option>
      </b-form-select>
    </b-form-group>
    <loading-panel v-if="loading"></loading-panel>
    <div v-else>
      <b-list-group flush v-if="deals.length > 0">
        <b-list-group-item v-for="deal in deals" :key="deal.id">
          <div>
            <h4 class="mb-0">{{ deal.name }}</h4>
            <p class="small mb-1">{{ deal.pipelineName }} <i class="fas fa-angle-double-right"></i> {{ deal.stageName }}</p>
            <p class="small mb-0">Price: {{ deal.price | currency }}</p>
            <p class="small">Close Date: <span v-if="deal.projectedCloseDate">{{ new Date(deal.projectedCloseDate) | date("MMM dd, Y") }}</span></p>
          </div>
          <b-dropdown variant="info" size="sm" id="deal-actions" text="Actions" v-if="owner">
            <b-dropdown-item @click="createListing(deal)">Create Listing</b-dropdown-item>
            <b-dropdown-item @click="createTransaction(deal)">Create Transaction</b-dropdown-item>
          </b-dropdown>
          <b-button size="sm" variant="info" v-b-toggle.deal-sidebar @click="dealId = deal.id" v-else>View Deal</b-button>
        </b-list-group-item>
      </b-list-group>
      <h3 class="text-danger text-center" v-else>No Deals</h3>
    </div>
    <deal :dealId="dealId" :userRoute="userRoute"></deal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import LoadingPanel from '@/components/LoadingPanel';
import Deal from './Deal';

export default {
  components: {
    LoadingPanel,
    Deal
  },
  data() {
    return {
      deals: [],
      loading: false,
      dealId: null,
      pipelines: null,
      pipelineId: '',
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute',
      roles: 'roles/roles'
    }),
    owner() {
      return this.roles.includes('owner');
    }
  },
  methods: {
    async getDeals() {
      this.loading = true;
      await axios.get(this.userRoute + "/integrations/fub/deals?pipelineId=" + this.pipelineId)
      .then(response => {
        this.deals = response.data;
        this.loading = false;
      })
      .catch(error => {
        // error
      });
    },
    async getPipelines() {
      await axios.get(this.userRoute + "/integrations/fub/pipelines")
      .then(response => {
        this.pipelines = response.data;
      })
      .catch(error => {
        // error
      });
    },
    createListing(deal) {
      this.$router.push({
        path: "/listings/create?deal=" + deal.id
      });
    },
    createTransaction(deal) {
      this.$router.push({
        path: "/transactions/create?deal=" + deal.id
      });
    }
  },
  created() {
    this.getDeals();
    this.getPipelines();
  }
};
</script>